module.exports = __webpack_public_path__ + "img/IMG_9257_T_L_WoodMatted.0355f6a0.jpg";